import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SentToIdentifyCommentPipe } from './pipes/sent-to-identify-comment/sent-to-identify-comment.pipe';
import { TabCommentsComponent } from './tab-comments.component';

@NgModule({
  entryComponents: [
    TabCommentsComponent
  ],
  declarations: [
    TabCommentsComponent,
    SentToIdentifyCommentPipe,
  ],
  imports: [
    TranslateModule,
    MatMenuModule,
    FuseSharedModule,
    MatTooltipModule,
    MatIconModule,
    MatToolbarModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatTabsModule,
    InfiniteScrollModule,
    MatProgressSpinnerModule,
  ],
  exports: [
    TabCommentsComponent,
  ]
})
export class TabCommentsModule {
}
